import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const [shrink, setShrink] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShrink(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* Animaciones integradas */}
      <style data-id="element-70">
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .fade-up {
            animation: fadeUp 0.8s ease forwards;
          }
        `}
      </style>

      <section className="pt-2 pb-1 px-6 md:pt-4 md:pb-1 max-w-6xl mx-auto -mt-8 transition-all duration-500" data-id="element-71">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-72">
          {/* TEXTO */}
          <div className="w-full md:w-[60%] flex flex-col items-start fade-up" data-id="element-73">
            {/* BADGE CON SHRINK */}
            <div className={`inline-flex items-center gap-2 bg-serene-blue text-white font-bold px-4 py-2 rounded-full text-sm mb-6 shadow-sm transition-all duration-500 ${shrink ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-74">
              ✨ Solo 2 minutos al día pueden cambiar tu relación con Dios
            </div>

            {/* TITULO + SUBTITULO CENTRADOS */}
            <div className="w-full text-center mb-10" data-id="element-75">
              <h1 className="font-fredoka text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight mb-6" data-id="element-76">
                365 Oraciones Poderosas para{' '}
                <span className="bg-sage-green/20 px-2 py-1 rounded-lg" data-id="element-77">
                  Hablar con Dios
                </span>{' '}
                Cada Día{' '}
                <span className="bg-serene-blue/20 px-2 py-1 rounded-lg" data-id="element-78">
                  (Aunque No Sepas Qué Decir)
                </span>
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-79">
                Un mensaje diario que{' '}
                <span className="bg-sage-green/20 px-1 rounded" data-id="element-80">te guía</span>,{' '}
                <span className="bg-sage-green/20 px-1 rounded" data-id="element-81">te calma</span>{' '}
                y fortalece tu fe en solo{' '}
                <span className="bg-serene-blue/20 px-1 rounded font-semibold" data-id="element-82">
                  2 minutos al día
                </span>
              </p>
            </div>

            {/* BULLETS */}
            <ul className="space-y-3 mb-8 w-full" data-id="element-83">
              {['No necesitas saber orar', 'Basado en versículos reales', 'Ideal para momentos difíciles', '1 oración lista cada día del año'].map((item, i) => <li key={i} className="flex items-center gap-3 text-charcoal font-semibold text-lg" data-id="element-84">
                  <CheckCircle2 className="w-6 h-6 text-sage-green flex-shrink-0" data-id="element-85" />
                  <span data-id="element-86">{item}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <div className="w-full flex flex-col items-center md:items-start" data-id="element-87">
              <button onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full md:w-auto bg-sage-green hover:bg-[#8ab075] text-white font-bold text-xl py-4 px-8 rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300" data-id="element-88">
                Empieza hoy tu conexión con Dios
              </button>
              <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-89">
                Garantía de devolución de 7 días sin preguntas
              </p>
            </div>
          </div>

          {/* IMAGEN */}
          <div className={`w-full md:w-[40%] relative transition-all duration-500 ${shrink ? 'scale-95' : 'scale-100'}`} data-id="element-90">
            <div className="absolute inset-0 bg-serene-blue/20 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-91"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wRTT2Gi4qcVztX9Y9ZrNzh/Diseno_sin_titulo_(52).png" alt="365 Días con Jesús Mockup" className="w-full h-auto rounded-3xl shadow-2xl object-cover transition-all duration-500" data-id="element-92" />
          </div>
        </div>
      </section>
    </>;
}